import { graphql } from '@/gql';
import type { CreateOperatorFaqMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { OperatorFaq } from '@/models/operatorFaq';

export const createOperatorFaq = async (data: CreateOperatorFaqMutationVariables['data']): Promise<OperatorFaq> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateOperatorFaq($data: OperatorFaqInputType!) {
        createOperatorFaq(data: $data) {
          id
          categories
          answer
          question
          relatedQuestions
          operator {
            firstName
            lastName
          }
          createdAt
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createOperatorFaq!;
};
